import { buildClientInvoicingSalesOrderUrl } from "../../reports/client-invoicing/salesOrderUrl";

const present = (value) => value !== null && value !== undefined && String(value).trim() !== "";

export const buildGeneratedInvoiceUrl = (row = {}) =>
  present(row?.id) ? `/generated-invoice/${encodeURIComponent(row.id)}` : null;

export const buildFinanceInvoicingRowLinks = (instanceUniqueId, row = {}) => ({
  invoiceUrl: buildGeneratedInvoiceUrl(row),
  salesOrderUrl: buildClientInvoicingSalesOrderUrl(instanceUniqueId, row),
});
